import axios from 'axios'
export default {
    namespaced: true,
    state: {
        name: 'CatalogVehicle',
		endpoint: '/catalog/vehicle',
		params: {},
        item: {},
        items: [],
    },
    actions: {
		/* find (context, id) {
			return axios.get(`${context.getters.endpoint}/${id}`).then(response => {
				//console.log('find','response.data', response.data)
				context.commit('item', response.data)
			}, error => {
				console.log(error)
			})
		},

		search (context, params) {
			return axios.get(context.getters.endpoint, { params: params }).then(response => {
				//console.log('search','response.data', response.data)
				context.commit('items', response.data)
			}, error => {
				console.log(error)
			})
		}, */
    }
}